export enum AddressTitlesEnum {
  'MR' = 'MR',
  'MRS' = 'MRS',
}

export enum TitlesEnum {
  'MR' = 'MR',
  'MRS' = 'MRS',
}
